import { ClipLoader } from 'react-spinners'
import { colors } from '../../services/style'

export function SL_ClipLoader(props) {
    return <ClipLoader color={colors.primary[100]} size={50} {...props} />
}
